import React,{ Component } from 'react';
import $ from 'jquery';
import { Link, browserHistory} from 'react-router';
import { Modal } from 'react-bootstrap';
const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets = 'https://aquadeals.in/admin/assets/';

export default class MyAquaCash extends Component{
	constructor(props)
	{
		super(props);
		this.state=
		{
			loading:false,
			balance:'',
			transactions:[],

			title:'',
			subtitle:'',
			type:'',
			date:'',
			amount:'',
			sign:'',
			modal_status:false,
		}
		this.transactionDetails=this.transactionDetails.bind(this);
		this.aquacash_Modal=this.aquacash_Modal.bind(this);
		this.close=this.close.bind(this);
	}
	componentDidMount()
	{
		if(screen.width >= 800)
		{
			window.location.href="/web/myaquacash";
		}
		if(!localStorage.user_id && !localStorage.token)
		{
			localStorage.setItem('myaquacash','/myaquacash');
			browserHistory.push('/login');
		}
		this.transactionDetails();
	}
	transactionDetails()
	{
		var data1={from: 'mobile_web',id: localStorage.getItem('user_id'),token:localStorage.getItem('token'),device_id: localStorage.getItem('push_device_id')}
	    var data2=JSON.stringify(data1);
	  
	    $.ajax({
	          method: 'POST',
	          url: baseUrl+'aquaCash',
	          dataType: 'json',
	          data:{req: data2},
	          success: function(data)
	          {
	          	
	          	this.setState({
	          		loading:true,
	          		balance:data.balance,
	          		transactions:data.transactions,
	            });
	          }.bind(this),
	          error: function(err){
	          }
	    });
	}
	aquacash_Modal(title,subtitle,amount,sign,type,date)
	{
		this.setState({
			modal_status:true,
			title:title,
			subtitle:subtitle,
			type:type,
			date:date,
			amount:amount,
			sign:sign,
		});
	}
	
	close()
	{
		this.setState({
			modal_status:false,
		});
	}

	render(){
	document.title ="My AquaCash | AquaDeals";
	var transactions= this.state.transactions.map(function(data,index){
		return(
			<li className="myaquacash_li" key={index} onClick={()=>{this.aquacash_Modal(data.title,data.subtitle,data.amount,data.sign,data.type,data.date)}}>
				  <h5>{data.title ? <span className="aquacash_title">{data.title}</span> : <span>&nbsp;</span>} {data.amount ? <span className="aquacash_amount">({data.sign}) &#8377; {data.amount}</span>: <span className="aquacash_amount">&nbsp;</span>}</h5>
				<h6 style={{paddingTop:'5px'}}> {data.subtitle ? <span className="aquacash_subtitle">{data.subtitle}</span> : <span>&nbsp;</span>} {data.type ? <span className={data.type==="Used" ? 'pull-right red cash_type': 'pull-right green cash_type'}>{data.type}</span> : <span>&nbsp;</span>}</h6>
				<h6 className="aquacash_date">Date {data.date}</h6>
			</li>
		);
	}.bind(this));
	
		return(
			<div className="mob_deals mob_aquacash_page">
				<div className="page_hdr">
					<div className="container-fluid">
						<h5><Link onClick={()=>{browserHistory.goBack()}}><i><img src={baseAssets+'icons/web_icons/close_icon1.png'} width="14px" className='cross_icon' alt=""/></i></Link><span className="header_text">MY AQUACASH</span></h5>
						<a href="/" className="myaquacash_amount">&#8377; {this.state.balance}</a>
					</div>
				</div>
				<div className="pag_cntnt">&nbsp;</div>
				{transactions.length > 0 ? 
				<section>
					<ul className="myaquacash_ul">
						{transactions}
					</ul>
				</section> : <div className="no_transactions_blk">No transactions were made</div>}
				<section className="botm_btns">
					<div>
						<Link style={{color:'#ff742a'}} to={'/share_earn'}><img src={baseAssets+"images/icons/nav_refer_earn.png"} width="30px" alt="" />SHARE & EARN </Link>
					</div>
				</section>
				<Modal className="aquacash_modal" show={this.state.modal_status} onHide={this.close} >
					<Modal.Body>
			  			<div>
			  					{this.state.title ? <h4>{this.state.title}</h4> : '' }
			  					<div>
			  						<p style={{marginTop:'20px'}}>{this.state.amount ? <span>&#8377;{this.state.amount}</span> : ''} {this.state.type ? this.state.type : ''} {this.state.subtitle ? 'for '+this.state.subtitle : ''} on {this.state.date} </p>
									<a style={{color:'#ff742a',textDecoration:'none',outline:'none',textAlign:'right',display:'block'}} onClick={this.close}>CLOSE</a>
			  					</div>
						</div>
			  		</Modal.Body>
			  	</Modal>
			</div>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Categories/Accounts/My_Aquacash.js
 **/